/**
 * A function to create a log object for the 'offerView' event (evid: 1)
 *
 * Event description: dealer offer viewed by user
 *
 * @param {offerViewParams} params - The parameters for this event
 * @property {GUID} loggedAccountId - logged in account context when offer was viewed
 * @property {GUID} offerId - the dealer offer
 * @property {GUID} assetId - asset_id
 * @property {string} topOfferName - top_offer_name
 * @property {GUID} realEstateId - the dealer real estate
 * @property {GUID} accountId - target account context when offer was viewed
 * @property {Url} http_referrer - http_referrer
 * @property {string} platform - platform
 * @property {GUID} msid - optional - the metasite where offer was viewed from
 * @property {GUID} loggedUserId - the actual user that viewed the offer
 * @return {LogObject<offerViewParams>} LogObject<offerViewParams>
 */
export function offerView(params) {
    return { evid: 1, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementPageClicksSrc115Evid13' event (evid: 13)
 *
 * Event description: user clicks on a CTA in the placements page
 *
 * @param {placementPageClicksSrc115Evid13Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} cta_type - ‘edit’/’form builder’/’publish’
 * @return {LogObject<placementPageClicksSrc115Evid13Params>} LogObject<placementPageClicksSrc115Evid13Params>
 */
export function placementPageClicksSrc115Evid13(params) {
    return { evid: 13, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerComparisonDebugNewService' event (evid: 1300)
 *
 * Event description: debug event for new banner service -temp event
 *
 * @param {dealerComparisonDebugNewServiceParams} params - The parameters for this event
 * @property {boolean} isError - some mismatch found
 * @property {boolean} isEqual - all comparisons matched
 * @property {boolean} isOfferIdEqual - offer_id is equal
 * @property {GUID} dealerBannersOfferId - banners offer_id
 * @property {string} servingPayload - sent only when there is a mismatch
 * @property {GUID} realEstateId - placement_id
 * @property {string} bannersPayload - banners_payload
 * @property {GUID} dealerBannersTemplateId - banners templates id
 * @property {GUID} dealerServingOfferId - serving offer_id
 * @property {GUID} dealerServingTemplateId - serving templated id
 * @property {boolean} isTemplateIdEqual - template_id is equal
 * @return {LogObject<dealerComparisonDebugNewServiceParams>} LogObject<dealerComparisonDebugNewServiceParams>
 */
export function dealerComparisonDebugNewService(params) {
    return { evid: 1300, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bannerServiceRequest' event (evid: 1368)
 *
 * Event description: Request coming from banner Service
 *
 * @param {bannerServiceRequestParams} params - The parameters for this event
 * @property {GUID} realEstateId - placement_id
 * @property {string} http_referrer - http_reffer
 * @property {GUID} msid - msid
 * @return {LogObject<bannerServiceRequestParams>} LogObject<bannerServiceRequestParams>
 */
export function bannerServiceRequest(params) {
    return { evid: 1368, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bannerServiceResponse' event (evid: 1369)
 *
 * Event description: Banner service response event (equivalent to event 5 in previous service)
 *
 * @param {bannerServiceResponseParams} params - The parameters for this event
 * @property {string} eligibleOffers - eligible offers
 * @property {string} realEstateId - placement id
 * @property {number} loadTime - seconds from request event to response event
 * @property {string} http_referrer - htto_reffere
 * @property {GUID} msid - msid
 * @return {LogObject<bannerServiceResponseParams>} LogObject<bannerServiceResponseParams>
 */
export function bannerServiceResponse(params) {
    return { evid: 1369, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementFormBuilderOptionsSrc115Evid14' event (evid: 14)
 *
 * Event description: user clicks on a CTA in the form builder
 *
 * @param {placementFormBuilderOptionsSrc115Evid14Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} cta_type - ‘load existing’/’playground’/’upload json’/’save form’
 * @return {LogObject<placementFormBuilderOptionsSrc115Evid14Params>} LogObject<placementFormBuilderOptionsSrc115Evid14Params>
 */
export function placementFormBuilderOptionsSrc115Evid14(params) {
    return { evid: 14, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementClickImportExistingSrc115Evid15' event (evid: 15)
 *
 * Event description: users clicks on import existing placement after choosing one
 *
 * @param {placementClickImportExistingSrc115Evid15Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} chosen_placement_id - chosen placement id
 * @return {LogObject<placementClickImportExistingSrc115Evid15Params>} LogObject<placementClickImportExistingSrc115Evid15Params>
 */
export function placementClickImportExistingSrc115Evid15(params) {
    return { evid: 15, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newSegmentCalculation' event (evid: 1501)
 *
 * Event description: bi that fire when the site segment is updated successfully
 *
 * @param {newSegmentCalculationParams} params - The parameters for this event
 * @property {string} calculationTrigger - what triggered the calculation (Dealer call, Category update, Migration)
 * @property {GUID} uuid - uuid
 * @property {string} industry_sub_category - industry sub category
 * @property {string} businessType - Business Type
 * @property {string} industry_category - Industry Category
 * @property {string} businessSegment - Business Segment Calculated
 * @property {string} businessTerm - Business Term
 * @property {string} calculationStatus - Succeeded/Failed
 * @property {GUID} msid - msid
 * @return {LogObject<newSegmentCalculationParams>} LogObject<newSegmentCalculationParams>
 */
export function newSegmentCalculation(params) {
    return { evid: 1501, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateSegmentFailed' event (evid: 1502)
 *
 * Event description: bi that fire when the site segment is calculated, contains site properties - business term, business type, main industry, sub industry and business segment
 *
 * @param {updateSegmentFailedParams} params - The parameters for this event
 * @property {string} businessTermInEnglish - Business Term Name, translated to english
 * @property {string} calculationTrigger - what triggered the calculation (Calculation Request, Category Update, Bulk Update)
 * @property {GUID} uuid - uuid
 * @property {string} businessType - Business Type
 * @property {string} businessSegment - Business Segment Calculated
 * @property {string} subIndustry - sub_industry
 * @property {string} businessTerm - Business Term
 * @property {GUID} businessTermID - Business Term ID
 * @property {boolean} isValidBusinessTerm - failed in fetching business term
 * @property {boolean} isValidSegment - failed in fetching business type/main industry/sub industry/business segment
 * @property {GUID} msid - msid
 * @property {string} mainIndustry - main_industry
 * @return {LogObject<updateSegmentFailedParams>} LogObject<updateSegmentFailedParams>
 */
export function updateSegmentFailed(params) {
    return { evid: 1502, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementSchemaPlaygroundClicksSrc115Evid16' event (evid: 16)
 *
 * Event description: user clicks on a CTA in schema playground
 *
 * @param {placementSchemaPlaygroundClicksSrc115Evid16Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} cta_type - ‘download data schema’/’download ui schema’
 * @return {LogObject<placementSchemaPlaygroundClicksSrc115Evid16Params>} LogObject<placementSchemaPlaygroundClicksSrc115Evid16Params>
 */
export function placementSchemaPlaygroundClicksSrc115Evid16(params) {
    return { evid: 16, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementUploadSchemaClickSrc115Evid17' event (evid: 17)
 *
 * Event description: user clicks on save when uploading schema
 *
 * @param {placementUploadSchemaClickSrc115Evid17Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @return {LogObject<placementUploadSchemaClickSrc115Evid17Params>} LogObject<placementUploadSchemaClickSrc115Evid17Params>
 */
export function placementUploadSchemaClickSrc115Evid17(params) {
    return { evid: 17, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnBullhornOpenDropdown' event (evid: 1701)
 *
 * Event description: fired when the dropdown is opened
 *
 * @param {clickOnBullhornOpenDropdownParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {string} articles_shown - list of article ids
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @property {Url} page_url - Page URL
 * @return {LogObject<clickOnBullhornOpenDropdownParams>} LogObject<clickOnBullhornOpenDropdownParams>
 */
export function clickOnBullhornOpenDropdown(params) {
    return { evid: 1701, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bullhornShown' event (evid: 1702)
 *
 * Event description: fired when the update center bullhorn is loaded
 *
 * @param {bullhornShownParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {boolean} is_badge_shown - indicates if the badge is shown
 * @property {number} updatesCount - number of updates in badge
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<bullhornShownParams>} LogObject<bullhornShownParams>
 */
export function bullhornShown(params) {
    return { evid: 1702, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewDropdown' event (evid: 1703)
 *
 * Event description: fired when the update center dropdown is visible on screen
 *
 * @param {viewDropdownParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {string} articles_shown - list of article IDs shown in dropdown (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<viewDropdownParams>} LogObject<viewDropdownParams>
 */
export function viewDropdown(params) {
    return { evid: 1703, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnArticleInDropdown' event (evid: 1704)
 *
 * Event description: fired when a user clicks on an article in update center dropdown
 *
 * @param {clickOnArticleInDropdownParams} params - The parameters for this event
 * @property {number} position_in_list - article position in dropdown
 * @property {string} uuid - uuid
 * @property {string} article_type - article type (new release|beta|partner update)
 * @property {GUID} article_id - article id (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnArticleInDropdownParams>} LogObject<clickOnArticleInDropdownParams>
 */
export function clickOnArticleInDropdown(params) {
    return { evid: 1704, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewModal' event (evid: 1706)
 *
 * Event description: fired when the update center modal is visible on screen
 *
 * @param {viewModalParams} params - The parameters for this event
 * @property {string} source - view all| from tab| from url | other
 * @property {string} tab_name - tab name all|features|beta|update
 * @property {string} uuid - uuid
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @property {boolean} has_articles - true = at least one article is visible. false = empty
 * @return {LogObject<viewModalParams>} LogObject<viewModalParams>
 */
export function viewModal(params) {
    return { evid: 1706, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewArticleInModal' event (evid: 1707)
 *
 * Event description: fired when the update center modal is visible on screen. article level
 *
 * @param {viewArticleInModalParams} params - The parameters for this event
 * @property {string} filtersList - list of filter selected by the user in the update center modal
 * @property {string} uuid - uuid
 * @property {string} article_type - article type
 * @property {GUID} article_id - article id (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<viewArticleInModalParams>} LogObject<viewArticleInModalParams>
 */
export function viewArticleInModal(params) {
    return { evid: 1707, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnArticleInModal' event (evid: 1709)
 *
 * Event description: fired when a user clicks on an a article in the update center dropdown
 *
 * @param {clickOnArticleInModalParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {string} article_type - article type
 * @property {GUID} article_id - article id (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<clickOnArticleInModalParams>} LogObject<clickOnArticleInModalParams>
 */
export function clickOnArticleInModal(params) {
    return { evid: 1709, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewArticleInModalInContext' event (evid: 1710)
 *
 * Event description: fired when an article in update center modal in context view is visible on screen
 *
 * @param {viewArticleInModalInContextParams} params - The parameters for this event
 * @property {string} source - modal|dropdown
 * @property {string} uuid - uuid
 * @property {string} article_type - article type (new release|beta|partner update)
 * @property {GUID} article_id - article id (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @return {LogObject<viewArticleInModalInContextParams>} LogObject<viewArticleInModalInContextParams>
 */
export function viewArticleInModalInContext(params) {
    return { evid: 1710, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickInArticleInModalInContext' event (evid: 1711)
 *
 * Event description: fired when a user clicks on an action in update center article in context view
 *
 * @param {clickInArticleInModalInContextParams} params - The parameters for this event
 * @property {string} uuid - uuid
 * @property {GUID} article_id - article id (when article source is dealer, article_id = offer_id)
 * @property {Url} pageurl - page url
 * @property {string} platform - editor|dashboard|mobile|wix studio
 * @property {GUID} msid - msid
 * @property {string} action - CTA_CLICK | JOIN_BETA
 * @return {LogObject<clickInArticleInModalInContextParams>} LogObject<clickInArticleInModalInContextParams>
 */
export function clickInArticleInModalInContext(params) {
    return { evid: 1711, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerErrorSrc115Evid18' event (evid: 18)
 *
 * Event description: Sent when there's an error in Dealer processes
 *
 * @param {dealerErrorSrc115Evid18Params} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {GUID} uuid - user id
 * @property {string} placement_id - placement id where offer was created
 * @property {string} type - type of server error. example: updateSchema
 * @property {string} description - error description
 * @property {string} offer_id - offer id
 * @return {LogObject<dealerErrorSrc115Evid18Params>} LogObject<dealerErrorSrc115Evid18Params>
 */
export function dealerErrorSrc115Evid18(params) {
    return { evid: 18, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementFormBuilderRenderedSrc115Evid19' event (evid: 19)
 *
 * Event description: Form builder page was rendered
 *
 * @param {placementFormBuilderRenderedSrc115Evid19Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} referral - where did the user came from the page (FT experience or edit)
 * @return {LogObject<placementFormBuilderRenderedSrc115Evid19Params>} LogObject<placementFormBuilderRenderedSrc115Evid19Params>
 */
export function placementFormBuilderRenderedSrc115Evid19(params) {
    return { evid: 19, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'offerMainCtaClick' event (evid: 2)
 *
 * Event description: dealer offer main cta clicked by the user
 *
 * @param {offerMainCtaClickParams} params - The parameters for this event
 * @property {GUID} offerId - the offer clicked by the user
 * @property {GUID} assetId - Some external asset guid. Can be the banner/LB campaign creative guid, but isn't specific to LB/banner assets.
 * @property {string} targetUrl - the url that is loaded once the cta is clicked.
 * @property {GUID} realEstateId - the dealer real estate
 * @property {number} actionPriority - 1= primary
 * 2= secondary. For CTA_CLICK action this is a mandatory field.
 * @property {Url} http_referrer - URL of a web page which is initial cause/source of the event (if available). Taken from HTTP headers on REST exposure when left blank
 * @property {string} platform - platform
 * @property {GUID} msid - optional - the metasite where offer was clicked from
 * @property {string} action - Type of the interaction: CTA_CLICK/CLOSE (other types to be added on demand)
 * @return {LogObject<offerMainCtaClickParams>} LogObject<offerMainCtaClickParams>
 */
export function offerMainCtaClick(params) {
    return { evid: 2, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'offerRetrievedAfterListOffersProcessSrc115Evid20' event (evid: 20)
 *
 * Event description: Dealer offer was retrieved after list offers targeting+frequency caps+limit
 * this is the offer the user is going to view
 *
 * @param {offerRetrievedAfterListOffersProcessSrc115Evid20Params} params - The parameters for this event
 * @property {GUID} offerId - dealer offer id
 * @property {string} placementId - dealer placement id
 * @return {LogObject<offerRetrievedAfterListOffersProcessSrc115Evid20Params>} LogObject<offerRetrievedAfterListOffersProcessSrc115Evid20Params>
 */
export function offerRetrievedAfterListOffersProcessSrc115Evid20(params) {
    return { evid: 20, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentStartGeneratingContentProcessSrc115Evid21' event (evid: 21)
 *
 * Event description: Start call to get the generated content
 * this call goes to cache -> if there's no adaptive content in the cache -> the AI will generate new content and store it -> for this kind of call we'll get the original content
 *
 * @param {adaptiveContentStartGeneratingContentProcessSrc115Evid21Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} external_id - external_id (msid+component id)
 * @return {LogObject<adaptiveContentStartGeneratingContentProcessSrc115Evid21Params>} LogObject<adaptiveContentStartGeneratingContentProcessSrc115Evid21Params>
 */
export function adaptiveContentStartGeneratingContentProcessSrc115Evid21(params) {
    return { evid: 21, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whatSNextResponse' event (evid: 2101)
 *
 * Event description: Fired on dealer 'what's next' service response
 *
 * @param {whatSNextResponseParams} params - The parameters for this event
 * @property {boolean} isFallback - if true, dealer reached time out and the user received the fallback strategy
 * @property {number} input_tokens - tokens used in the AI prompt
 * @property {string} uuid - uuid
 * @property {string} advices - array containing Jsons of 3 fields: question, suggested_whats_next_action, next_action_explanation
 * @property {number} output_tokens - tokens used in the response from AI
 * @property {string} prompt_params - prompt_params
 * @property {number} user_context_latency - user_context_latency
 * @property {number} cost - cost of LLM call in microcents
 * @property {number} api_latency - api_latency
 * @property {number} llm_latency - llm_latency
 * @property {string} user_context_source - LLM || Cache
 * @return {LogObject<whatSNextResponseParams>} LogObject<whatSNextResponseParams>
 */
export function whatSNextResponse(params) {
    return { evid: 2101, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentSuccessGeneratingContentProcessSrc115Evid22' event (evid: 22)
 *
 * Event description: Call to get the generated content succeeded
 * this call goes to cache -> if there's no adaptive content in the cache -> the AI will generate new content and store it -> for this kind of call we'll get the original content
 *
 * @param {adaptiveContentSuccessGeneratingContentProcessSrc115Evid22Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} external_id - external_id (msid+component id)
 * @property {string} is_original_content - true/false
 * what the uou actually saw
 * @property {number} duration - in ms
 * @return {LogObject<adaptiveContentSuccessGeneratingContentProcessSrc115Evid22Params>} LogObject<adaptiveContentSuccessGeneratingContentProcessSrc115Evid22Params>
 */
export function adaptiveContentSuccessGeneratingContentProcessSrc115Evid22(params) {
    return { evid: 22, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentErrorGeneratingContentProcessSrc115Evid23' event (evid: 23)
 *
 * Event description: The call to get the generated content failed
 *
 * @param {adaptiveContentErrorGeneratingContentProcessSrc115Evid23Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} external_id - external_id (msid+component id)
 * @property {string} error_reason - error reason
 * @return {LogObject<adaptiveContentErrorGeneratingContentProcessSrc115Evid23Params>} LogObject<adaptiveContentErrorGeneratingContentProcessSrc115Evid23Params>
 */
export function adaptiveContentErrorGeneratingContentProcessSrc115Evid23(params) {
    return { evid: 23, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerSimulationStarted' event (evid: 2301)
 *
 * Event description: Fired when a dealer BO simulation has started
 *
 * @param {dealerSimulationStartedParams} params - The parameters for this event
 * @property {GUID} simulationID - simulation ID
 * @property {string} username - Dealer BO username
 * @property {string} priorityStrategyConfig - JSON with the prioritization strategy configuration tested in the simulation
 * @property {GUID} realEstateId - Placement ID
 * @return {LogObject<dealerSimulationStartedParams>} LogObject<dealerSimulationStartedParams>
 */
export function dealerSimulationStarted(params) {
    return { evid: 2301, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerNewTestWidgetRenderedSrc115Evid24' event (evid: 24)
 *
 * Event description: When the first step in the widget of new test  is opened
 *
 * @param {aiContentOptimizerNewTestWidgetRenderedSrc115Evid24Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {string} referral - where did the widget opened from: ‘dropdown’/’panel’
 * @property {GUID} offer_id - offer id
 * @property {GUID} flow_guid - flow_guid
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerNewTestWidgetRenderedSrc115Evid24Params>} LogObject<aiContentOptimizerNewTestWidgetRenderedSrc115Evid24Params>
 */
export function aiContentOptimizerNewTestWidgetRenderedSrc115Evid24(params) {
    return { evid: 24, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerSubmitTestBasicsSrc115Evid25' event (evid: 25)
 *
 * Event description: When user clicks on 'next' at the first step of test basics
 *
 * @param {aiContentOptimizerSubmitTestBasicsSrc115Evid25Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {string} test_name - test name
 * @property {string} test_field - offer creative field
 * @property {GUID} test_guid - only for edit mode
 * @property {GUID} flow_guid - id for each attempt (for all modes)
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerSubmitTestBasicsSrc115Evid25Params>} LogObject<aiContentOptimizerSubmitTestBasicsSrc115Evid25Params>
 */
export function aiContentOptimizerSubmitTestBasicsSrc115Evid25(params) {
    return { evid: 25, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerChangeVariantClicksSrc115Evid26' event (evid: 26)
 *
 * Event description: When user changes the content of a variant (by edit/regenerate)
 *
 * @param {aiContentOptimizerChangeVariantClicksSrc115Evid26Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - only for edit mode
 * @property {string} persona - name of persona
 * @property {string} cta_type - button name clicked
 * @property {string} persona_first_content - first content rendered for persona
 * @property {GUID} flow_guid - id for each attempt (for all modes)
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerChangeVariantClicksSrc115Evid26Params>} LogObject<aiContentOptimizerChangeVariantClicksSrc115Evid26Params>
 */
export function aiContentOptimizerChangeVariantClicksSrc115Evid26(params) {
    return { evid: 26, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerClickRegenerateAllVariantsSrc115Evid27' event (evid: 27)
 *
 * Event description: When user changes the content for all variants by clicking 'regenerate all'
 *
 * @param {aiContentOptimizerClickRegenerateAllVariantsSrc115Evid27Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - only for edit mode
 * @property {GUID} flow_guid - id for each attempt (for all modes)
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerClickRegenerateAllVariantsSrc115Evid27Params>} LogObject<aiContentOptimizerClickRegenerateAllVariantsSrc115Evid27Params>
 */
export function aiContentOptimizerClickRegenerateAllVariantsSrc115Evid27(params) {
    return { evid: 27, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerSubmitVariantsSrc115Evid28' event (evid: 28)
 *
 * Event description: When user clicks on next in selecting variants step and submits his choice
 *
 * @param {aiContentOptimizerSubmitVariantsSrc115Evid28Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - only for edit mode
 * @property {string} chosen_personas - array of personas chosen (including ‘custom’)
 * @property {string} flow_guid - id for each attempt (for all modes)
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerSubmitVariantsSrc115Evid28Params>} LogObject<aiContentOptimizerSubmitVariantsSrc115Evid28Params>
 */
export function aiContentOptimizerSubmitVariantsSrc115Evid28(params) {
    return { evid: 28, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerSaveDraftClickSrc115Evid29' event (evid: 29)
 *
 * Event description: When user clicks on 'save draft' in choosing variants step
 *
 * @param {aiContentOptimizerSaveDraftClickSrc115Evid29Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - only for edit mode
 * @property {string} chosen_personas - array of personas chosen (including ‘custom’)
 * @property {GUID} flow_guid - id for each attempt (for all modes)
 * @return {LogObject<aiContentOptimizerSaveDraftClickSrc115Evid29Params>} LogObject<aiContentOptimizerSaveDraftClickSrc115Evid29Params>
 */
export function aiContentOptimizerSaveDraftClickSrc115Evid29(params) {
    return { evid: 29, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerSubmitTestSrc115Evid30' event (evid: 30)
 *
 * Event description: When user finishes the widget and submits a test
 *
 * @param {aiContentOptimizerSubmitTestSrc115Evid30Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - only for edit mode
 * @property {number} duration - in days
 * @property {string} kpi_ids - array with all kpi ids
 * @property {GUID} flow_guid - id for each attempt (for all modes)
 * @property {string} mode - new/edit
 * @property {string} button_type - primary/secondary
 * @property {string} chosen_personas - chosen personas
 * @return {LogObject<aiContentOptimizerSubmitTestSrc115Evid30Params>} LogObject<aiContentOptimizerSubmitTestSrc115Evid30Params>
 */
export function aiContentOptimizerSubmitTestSrc115Evid30(params) {
    return { evid: 30, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerClickRunTestSrc115Evid31' event (evid: 31)
 *
 * Event description: When user clicks on run test and starts it
 *
 * @param {aiContentOptimizerClickRunTestSrc115Evid31Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - test id
 * @property {number} chosen_duration - in days
 * @property {GUID} experiment_id - experiment_id
 * @property {string} wixer_id - number of test in petri
 * @return {LogObject<aiContentOptimizerClickRunTestSrc115Evid31Params>} LogObject<aiContentOptimizerClickRunTestSrc115Evid31Params>
 */
export function aiContentOptimizerClickRunTestSrc115Evid31(params) {
    return { evid: 31, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerExistingTestActionsSrc115Evid32' event (evid: 32)
 *
 * Event description: Action made on test - delete/results/change dates...
 *
 * @param {aiContentOptimizerExistingTestActionsSrc115Evid32Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - test id
 * @property {string} test_status - ‘draft’/’active’/’ended’
 * @property {string} action - action made on test
 * @return {LogObject<aiContentOptimizerExistingTestActionsSrc115Evid32Params>} LogObject<aiContentOptimizerExistingTestActionsSrc115Evid32Params>
 */
export function aiContentOptimizerExistingTestActionsSrc115Evid32(params) {
    return { evid: 32, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerOpenVariantToAllUsersSrc115Evid33' event (evid: 33)
 *
 * Event description: When test ends and user opens one of the variants to all
 *
 * @param {aiContentOptimizerOpenVariantToAllUsersSrc115Evid33Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - test id
 * @property {string} persona_opened - the persona of the variant that was open to all users
 * @return {LogObject<aiContentOptimizerOpenVariantToAllUsersSrc115Evid33Params>} LogObject<aiContentOptimizerOpenVariantToAllUsersSrc115Evid33Params>
 */
export function aiContentOptimizerOpenVariantToAllUsersSrc115Evid33(params) {
    return { evid: 33, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerTestForceStopClickSrc115Evid34' event (evid: 34)
 *
 * Event description: When user clicks on 'force stop now' and stops the test
 *
 * @param {aiContentOptimizerTestForceStopClickSrc115Evid34Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - test id
 * @property {number} running_duration - number of days the test ran
 * @property {GUID} experiment_id - experiment_id
 * @property {string} wixer_id - number of wixer test id
 * @return {LogObject<aiContentOptimizerTestForceStopClickSrc115Evid34Params>} LogObject<aiContentOptimizerTestForceStopClickSrc115Evid34Params>
 */
export function aiContentOptimizerTestForceStopClickSrc115Evid34(params) {
    return { evid: 34, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerChangeCreativeFieldSrc115Evid35' event (evid: 35)
 *
 * Event description: When user changes the creative field (going back in wizard, changes and continues)
 *
 * @param {aiContentOptimizerChangeCreativeFieldSrc115Evid35Params} params - The parameters for this event
 * @property {string} username - user name
 * @property {GUID} uuid - user id
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @property {GUID} test_guid - test id
 * @property {string} test_field - offer creative new field
 * @property {string} mode - new/edit
 * @return {LogObject<aiContentOptimizerChangeCreativeFieldSrc115Evid35Params>} LogObject<aiContentOptimizerChangeCreativeFieldSrc115Evid35Params>
 */
export function aiContentOptimizerChangeCreativeFieldSrc115Evid35(params) {
    return { evid: 35, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerTestEndedDetailsSrc115Evid36' event (evid: 36)
 *
 * Event description: Test ended details
 *
 * @param {aiContentOptimizerTestEndedDetailsSrc115Evid36Params} params - The parameters for this event
 * @property {GUID} test_guid - test id
 * @property {number} running_duration - number of days the test actually ran
 * @property {DateTime} test_end_date - the date the test ended
 * @property {string} test_end_result - version and KPI winned (without original version as winner)
 * @property {GUID} experiment_id - experiment_id
 * @property {string} wixer_id - number of wixer test
 * @property {string} test_stop_reason - user / duration expired
 * @return {LogObject<aiContentOptimizerTestEndedDetailsSrc115Evid36Params>} LogObject<aiContentOptimizerTestEndedDetailsSrc115Evid36Params>
 */
export function aiContentOptimizerTestEndedDetailsSrc115Evid36(params) {
    return { evid: 36, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerGenerateVariantsRetrySrc115Evid37' event (evid: 37)
 *
 * Event description: Generate variants retry on our side (if the validator of the content give us response that the generated content isn't valid)
 *
 * @param {aiContentOptimizerGenerateVariantsRetrySrc115Evid37Params} params - The parameters for this event
 * @property {string} reason - reason for retry
 * @property {string} original_content - original content
 * @property {string} persona - persona
 * @property {string} generated_content - generated_content
 * @return {LogObject<aiContentOptimizerGenerateVariantsRetrySrc115Evid37Params>} LogObject<aiContentOptimizerGenerateVariantsRetrySrc115Evid37Params>
 */
export function aiContentOptimizerGenerateVariantsRetrySrc115Evid37(params) {
    return { evid: 37, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerGenerateVariantsErrorSrc115Evid38' event (evid: 38)
 *
 * Event description: Generate variants error
 *
 * @param {aiContentOptimizerGenerateVariantsErrorSrc115Evid38Params} params - The parameters for this event
 * @property {string} reason - reason for error
 * @return {LogObject<aiContentOptimizerGenerateVariantsErrorSrc115Evid38Params>} LogObject<aiContentOptimizerGenerateVariantsErrorSrc115Evid38Params>
 */
export function aiContentOptimizerGenerateVariantsErrorSrc115Evid38(params) {
    return { evid: 38, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerLlmSuccessGenerateContentSrc115Evid39' event (evid: 39)
 *
 * Event description: LLM succeeded in generating content
 *
 * @param {aiContentOptimizerLlmSuccessGenerateContentSrc115Evid39Params} params - The parameters for this event
 * @property {string} persona - persona
 * @property {string} original_content - original content
 * @property {string} generated_content - generated content
 * @return {LogObject<aiContentOptimizerLlmSuccessGenerateContentSrc115Evid39Params>} LogObject<aiContentOptimizerLlmSuccessGenerateContentSrc115Evid39Params>
 */
export function aiContentOptimizerLlmSuccessGenerateContentSrc115Evid39(params) {
    return { evid: 39, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'realEstateRequest' event (evid: 4)
 *
 * Event description: When the dealer placement is called , server side.
 *
 * @param {realEstateRequestParams} params - The parameters for this event
 * @property {GUID} realEstateId - the dealer real-estate id
 * @property {Url} http_referrer - the page the user landed on (for example Business manager url)
 * @property {GUID} msid - optional - the metasite where offer was viewed from
 * @return {LogObject<realEstateRequestParams>} LogObject<realEstateRequestParams>
 */
export function realEstateRequest(params) {
    return { evid: 4, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerLlmErrorGenerateContentSrc115Evid40' event (evid: 40)
 *
 * Event description: LLM had an error in generating content
 *
 * @param {aiContentOptimizerLlmErrorGenerateContentSrc115Evid40Params} params - The parameters for this event
 * @property {string} persona - persona
 * @property {string} original_content - original content
 * @property {string} reason - reason
 * @return {LogObject<aiContentOptimizerLlmErrorGenerateContentSrc115Evid40Params>} LogObject<aiContentOptimizerLlmErrorGenerateContentSrc115Evid40Params>
 */
export function aiContentOptimizerLlmErrorGenerateContentSrc115Evid40(params) {
    return { evid: 40, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'aiContentOptimizerNoUserDetailsForOfferRetrievedSrc115Evid41' event (evid: 41)
 *
 * Event description: to monitor invalid events in 115:20 (each time 115:20 comes with no uuid/client id)
 *
 * @param {aiContentOptimizerNoUserDetailsForOfferRetrievedSrc115Evid41Params} params - The parameters for this event
 * @property {GUID} placement_id - placement id
 * @property {GUID} offer_id - offer id
 * @return {LogObject<aiContentOptimizerNoUserDetailsForOfferRetrievedSrc115Evid41Params>} LogObject<aiContentOptimizerNoUserDetailsForOfferRetrievedSrc115Evid41Params>
 */
export function aiContentOptimizerNoUserDetailsForOfferRetrievedSrc115Evid41(params) {
    return { evid: 41, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentLlmProcessSrc115Evid42' event (evid: 42)
 *
 * Event description: To monitor LLM performance
 *
 *
 * @param {adaptiveContentLlmProcessSrc115Evid42Params} params - The parameters for this event
 * @property {number} duration - in min
 * @property {string} original_content - original content
 * @property {string} adaptive_content - LLM result content
 * @property {string} prompt_parameters - json with all parameters and their values including special instruction
 * @property {string} is_simulation - if the content came from simulation or uou render
 * @property {string} guidelines - guidelines of the prompt
 * @return {LogObject<adaptiveContentLlmProcessSrc115Evid42Params>} LogObject<adaptiveContentLlmProcessSrc115Evid42Params>
 */
export function adaptiveContentLlmProcessSrc115Evid42(params) {
    return { evid: 42, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentRenderedContentSrc115Evid43' event (evid: 43)
 *
 * Event description: What the user actually saw - original or adaptive content
 *
 * @param {adaptiveContentRenderedContentSrc115Evid43Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {boolean} is_origin_content - true/false
 * @return {LogObject<adaptiveContentRenderedContentSrc115Evid43Params>} LogObject<adaptiveContentRenderedContentSrc115Evid43Params>
 */
export function adaptiveContentRenderedContentSrc115Evid43(params) {
    return { evid: 43, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveContentContentFromCacheSrc115Evid44' event (evid: 44)
 *
 * Event description: Call to get the generated content succeeded
 * this call goes to cache -> if there's no adaptive content in the cache -> the AI will generate new content and store it -> for this kind of call we'll get the original content
 *
 * @param {adaptiveContentContentFromCacheSrc115Evid44Params} params - The parameters for this event
 * @property {number} duration - in ms
 * @return {LogObject<adaptiveContentContentFromCacheSrc115Evid44Params>} LogObject<adaptiveContentContentFromCacheSrc115Evid44Params>
 */
export function adaptiveContentContentFromCacheSrc115Evid44(params) {
    return { evid: 44, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveSimulatorModalOpenedSrc115Evid45' event (evid: 45)
 *
 * Event description: Adaptive Simulator - Modal Opened
 *
 * @param {adaptiveSimulatorModalOpenedSrc115Evid45Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} external_id - external_id (msid+component id)
 * @property {string} referral - where it was opened from
 * @property {string} adaptive_type - what the type that we make adaptive
 * @return {LogObject<adaptiveSimulatorModalOpenedSrc115Evid45Params>} LogObject<adaptiveSimulatorModalOpenedSrc115Evid45Params>
 */
export function adaptiveSimulatorModalOpenedSrc115Evid45(params) {
    return { evid: 45, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveSimulatorClickSimulateSrc115Evid46' event (evid: 46)
 *
 * Event description: Adaptive Simulator - Click Simulate
 *
 * @param {adaptiveSimulatorClickSimulateSrc115Evid46Params} params - The parameters for this event
 * @property {string} component_id - component_id
 * @property {string} external_id - external_id (msid+component id)
 * @property {string} adaptive_type - what the type that we make adaptive
 * @property {string} guidelines - guidelines user entered
 * @property {string} parameters - parameters used in the simulation and their values
 * @return {LogObject<adaptiveSimulatorClickSimulateSrc115Evid46Params>} LogObject<adaptiveSimulatorClickSimulateSrc115Evid46Params>
 */
export function adaptiveSimulatorClickSimulateSrc115Evid46(params) {
    return { evid: 46, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveSimulatorClearResultsClickSrc115Evid47' event (evid: 47)
 *
 * Event description: Adaptive Simulator - Clear Results Click
 *
 * @param {adaptiveSimulatorClearResultsClickSrc115Evid47Params} params - The parameters for this event
 * @property {string} numbers_simulations - number of versions that were cleared
 * @return {LogObject<adaptiveSimulatorClearResultsClickSrc115Evid47Params>} LogObject<adaptiveSimulatorClearResultsClickSrc115Evid47Params>
 */
export function adaptiveSimulatorClearResultsClickSrc115Evid47(params) {
    return { evid: 47, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'adaptiveSimulatorCopyClickSrc115Evid48' event (evid: 48)
 *
 * Event description: Adaptive Simulator - Copy Click
 *
 * @param {adaptiveSimulatorCopyClickSrc115Evid48Params} params - The parameters for this event
 * @property {string} parameters - parameters and values of the simulation
 * @property {string} guidelines - guidelines that were copied for the version
 * @return {LogObject<adaptiveSimulatorCopyClickSrc115Evid48Params>} LogObject<adaptiveSimulatorCopyClickSrc115Evid48Params>
 */
export function adaptiveSimulatorCopyClickSrc115Evid48(params) {
    return { evid: 48, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'realEstateResponse' event (evid: 5)
 *
 * Event description: When the dealer placement in response to the call returns an offer/offers , server side.
 *
 * @param {realEstateResponseParams} params - The parameters for this event
 * @property {string} dynamicFields - json of the dynamic fields in the offering and their ouput: {dynamic_field : output }
 * @property {string} eligibleOffers - list/concated strings of all the offers that matched the targeting + frequency cap in dealer check
 * @property {string} inputTargetingLng - language used to calculate offer targeting language
 * @property {string} rejected_frequency_caps - dictionary : {offer_id : freq _cap_reject_reason}/ list of offerings that matched targeting but weren't shown because of frequency cap + what freq cap reason
 * @property {GUID} realEstateId - the dealer real-estate id
 * @property {boolean} isCreativeFeatureToggle - if new creative feature toggle is on
 * @property {boolean} isPlacementOptIn - if placement is opt in for using new creative flow
 * @property {string} placementSlug - placement slug - optional
 * @property {boolean} isNewCreativeAssets - if assets returned are from new creative flow
 * @property {string} matched_targeting - list/concated strings of all the offers that matched the targeting in dealer check
 * @property {number} loadTime - The time delta between event 4 and event 5 - how long it took the dealer to respond to a request. Helps monitor dealer performance
 * @property {Url} http_referrer - the page the user landed on (for example Business manager url)
 * @property {GUID} msid - optional - the metasite where offer was viewed from
 * @property {string} priority_strategy - Priority strategy algorithm
 * @return {LogObject<realEstateResponseParams>} LogObject<realEstateResponseParams>
 */
export function realEstateResponse(params) {
    return { evid: 5, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'profileServiceCacheMiss' event (evid: 50)
 *
 * Event description: When dealer gets empty response from profile service because of cache not warmed up
 *
 * @param {profileServiceCacheMissParams} params - The parameters for this event
 * @property {boolean} success - true if service returned not empty profile
 * @property {GUID} profileMetasiteGuid - requested metasite id
 * @property {GUID} realEstateId - which real estate required the profile service
 * @property {string} fields - comma-separated fields requested from profile service
 * @property {GUID} profileAccountGuid - requested user id
 * @property {string} type - What kind of profile was requested ("account" || "metasite")
 * @return {LogObject<profileServiceCacheMissParams>} LogObject<profileServiceCacheMissParams>
 */
export function profileServiceCacheMiss(params) {
    return { evid: 50, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'boPageViewFirstRender' event (evid: 501)
 *
 * Event description: View event (first render) for the dealer BO
 *
 * @param {boPageViewFirstRenderParams} params - The parameters for this event
 * @property {Url} page_url - page url
 * @property {string} username - name of employee (email prefix)
 * @return {LogObject<boPageViewFirstRenderParams>} LogObject<boPageViewFirstRenderParams>
 */
export function boPageViewFirstRender(params) {
    return { evid: 501, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newBoOffersMismatch' event (evid: 51)
 *
 * Event description: If new vs old BO offers mismatch for dealer runtime "list offers for placement" request
 *
 * @param {newBoOffersMismatchParams} params - The parameters for this event
 * @property {number} oldOffersCount - Total number of old BO offers for this placement
 * @property {number} oldMissedOffersCount - How many offers from old BO are not in the new BO list
 * @property {number} newMissedOffersCount - How many offers from new BO are not in old BO offers list
 * @property {string} oldMissedOffers - JSON array of offers from old BO that are not in the new BO list
 * @property {string} newMissedOffers - JSON array of offers from new BO that are not in old BO offers list
 * @property {number} comparationTimeMs - How much time it took to make offers deep comparation
 * @property {number} newOffersCount - Total number of new BO offers for this placement
 * @property {GUID} placementId - Placement id for this offers list request
 * @return {LogObject<newBoOffersMismatchParams>} LogObject<newBoOffersMismatchParams>
 */
export function newBoOffersMismatch(params) {
    return { evid: 51, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerComparisonDebugNewTargetingService' event (evid: 53)
 *
 * Event description: debug event for new targeting service for dynamic params - temp event
 *
 * @param {dealerComparisonDebugNewTargetingServiceParams} params - The parameters for this event
 * @property {string} currentFlowDynamicParams - a json containing the dynamic params of all eligible offers by the current flow
 * @property {string} newFlowStatus - success/error
 * @property {boolean} isDeviantArt - is deviant art user
 * @property {string} uuid - uuid
 * @property {boolean} didFetchFilterInput - if serving-service has dataToFetch
 * @property {GUID} realEstateId - placement id
 * @property {number} newFlowDuration - duration of new flow in mili-seconds
 * @property {string} newFlowDynamicParams - a json containing the dynamic params of all eligible offers by the new flow
 * @property {string} newFlowEligibleOffers - eligible offers by new flow
 * @property {boolean} isEqualEligibleOffers - indicate if returned offers are equal for both flows
 * @property {string} currentFlowEligibleOffers - eligible offers by current flow
 * @property {boolean} isEqualDynamicParams - indicate if dynamic params are equal in both flows
 * @property {string} msid - msid
 * @property {string} currentFlowStatus - success/error
 * @property {number} currentFlowDuration - duration of current flow in mili-seconds
 * @return {LogObject<dealerComparisonDebugNewTargetingServiceParams>} LogObject<dealerComparisonDebugNewTargetingServiceParams>
 */
export function dealerComparisonDebugNewTargetingService(params) {
    return { evid: 53, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'realEstateFilteringCalculation' event (evid: 6)
 *
 * Event description: When the dealer responds to a call - returns what offers matched/didn't matched/rejected by frequency cap
 *
 * @param {realEstateFilteringCalculationParams} params - The parameters for this event
 * @property {string} rejected_frequency_caps - dictionary : {offer_id : freq _cap_reject_reason}/ list of offerings that matched targeting but weren't shown because of frequency cap + what freq cap reason
 * @property {GUID} realEstateId - placement_id
 * @property {string} matched_targeting - list/concated strings of all the offers that matched the targeting in dealer check
 * @property {string} rejectedOfferIds - list/concated strings of all the offers that  did NOT match targeting
 * @property {GUID} msid - optional - the metasite where offer was viewed from
 * @property {string} eligible_offers - eligible = all offers matched targeting without offers rejected by frequency cap
 * @return {LogObject<realEstateFilteringCalculationParams>} LogObject<realEstateFilteringCalculationParams>
 */
export function realEstateFilteringCalculation(params) {
    return { evid: 6, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'createOffer' event (evid: 601)
 *
 * Event description: Sent when an offer is created in dealer BO
 *
 * @param {createOfferParams} params - The parameters for this event
 * @property {GUID} assetId - Some external asset guid. Can be the banner/LB campaign creative guid, but isn't specific to LB/banner assets.
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - the name given to the offer created
 * @property {GUID} realEstateId - placement id where offer was created
 * @property {GUID} offer_id - offer id of offer created
 * @return {LogObject<createOfferParams>} LogObject<createOfferParams>
 */
export function createOffer(params) {
    return { evid: 601, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateOffer' event (evid: 602)
 *
 * Event description: Sent when an offer is updated in dealer BO- full update
 *
 * @param {updateOfferParams} params - The parameters for this event
 * @property {GUID} connected_kpi - guid of kpi connected, if none then null
 * @property {GUID} assetId - Some external asset guid. Can be the banner/LB campaign creative guid, but isn't specific to LB/banner assets.
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of offer
 * @property {GUID} realEstateId - placement id
 * @property {GUID} offer_id - id of offer
 * @return {LogObject<updateOfferParams>} LogObject<updateOfferParams>
 */
export function updateOffer(params) {
    return { evid: 602, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'changeOfferStatus' event (evid: 603)
 *
 * Event description: Sent when the status of an offer is changed (activate/deactivate/restore/archive )
 *
 * @param {changeOfferStatusParams} params - The parameters for this event
 * @property {string} previousStatus - status before change
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of offer
 * @property {GUID} realEstateId - placement id
 * @property {string} new_status - new status- status after change
 * @property {GUID} offer_id - id of offer
 * @return {LogObject<changeOfferStatusParams>} LogObject<changeOfferStatusParams>
 */
export function changeOfferStatus(params) {
    return { evid: 603, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'priorityChange' event (evid: 604)
 *
 * Event description: Sent when priorities in a placement are changed
 *
 * @param {priorityChangeParams} params - The parameters for this event
 * @property {string} previous_offer_order - string with offer ids by their previous order before the change
 * @property {string} username - name of employee (email prefix)
 * @property {GUID} realEstateId - placement id
 * @property {string} new_offer_order - string with offer ids by their new priority order
 * @return {LogObject<priorityChangeParams>} LogObject<priorityChangeParams>
 */
export function priorityChange(params) {
    return { evid: 604, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'disconnectOfferFromCampaign' event (evid: 605)
 *
 * Event description: Disconnect an offer from it's campaign
 *
 * @param {disconnectOfferFromCampaignParams} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of the offer
 * @property {GUID} realEstateId - id of the placement of the offer
 * @property {GUID} offer_id - id of the offer
 * @property {GUID} campaign_id - id of the campaign removed from
 * @return {LogObject<disconnectOfferFromCampaignParams>} LogObject<disconnectOfferFromCampaignParams>
 */
export function disconnectOfferFromCampaign(params) {
    return { evid: 605, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'connectOfferToCampaign' event (evid: 606)
 *
 * Event description: Event is sent when an offer is connected to a campaign
 *
 * @param {connectOfferToCampaignParams} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of the offer
 * @property {string} realEstateId - placement id of the offer
 * @property {GUID} offer_id - id of the offer
 * @property {GUID} campaign_id - id of the campaign
 * @return {LogObject<connectOfferToCampaignParams>} LogObject<connectOfferToCampaignParams>
 */
export function connectOfferToCampaign(params) {
    return { evid: 606, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateOfferDetailed' event (evid: 608)
 *
 * Event description: When an offer is updated, an event is fired for every section that had changes in it.
 *
 * @param {updateOfferDetailedParams} params - The parameters for this event
 * @property {string} username - wix username
 * @property {string} offer_name - updated offer name
 * @property {string} old_value - Json of the offer section before the update
 * @property {string} changed_section - the section in the offer that was changed:  Metadata| KPI | Schedule | Creative | Frequency Cap | Targeting - Brand | Targeting - Project Type | Targeting - Country | Targeting - Language | Targeting - Audience | Targeting - AB Test
 * @property {GUID} realEstateId - placement id
 * @property {GUID} offer_id - updated offer id
 * @property {string} new_value - Json of the offer section after the update
 * @return {LogObject<updateOfferDetailedParams>} LogObject<updateOfferDetailedParams>
 */
export function updateOfferDetailed(params) {
    return { evid: 608, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'editPlacementInfo' event (evid: 609)
 *
 * Event description: fired when placement info is updated successfully (placement metadata: name, group, description, level, url, manager, guidelines or image), every field that changed will be in different event
 *
 * @param {editPlacementInfoParams} params - The parameters for this event
 * @property {string} username - username
 * @property {string} old_value - Json of the placement section before the update
 * @property {GUID} realEstateId - Placement ID
 * @property {string} fieldName - The placement field that changed
 * @property {string} new_value - Json of the placement section after the update
 * @property {string} placementStatus - active | draft | archive
 * @return {LogObject<editPlacementInfoParams>} LogObject<editPlacementInfoParams>
 */
export function editPlacementInfo(params) {
    return { evid: 609, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'placementSchemaUpdate' event (evid: 610)
 *
 * Event description: fired when placement schema is updated successfully
 *
 * @param {placementSchemaUpdateParams} params - The parameters for this event
 * @property {string} username - username
 * @property {string} old_value - Json of the placement schema before the update
 * @property {GUID} realEstateId - Placement ID
 * @property {string} new_value - Json of the placement schema after the update
 * @property {string} placementStatus - active | draft
 * @property {GUID} uuid - user id (added in Sep 2024)
 * @return {LogObject<placementSchemaUpdateParams>} LogObject<placementSchemaUpdateParams>
 */
export function placementSchemaUpdate(params) {
    return { evid: 610, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'priorityServiceQaEvent' event (evid: 7)
 *
 * Event description: A temp event for QAing the new dealer priority service
 *
 * @param {priorityServiceQaEventParams} params - The parameters for this event
 * @property {string} priorityServiceResult - Json of eligible offers prioritized by priority service
 * @property {string} domainPriorityResult - Json of eligible offers prioritized by domain priority
 * @property {GUID} placementId - placement id
 * @return {LogObject<priorityServiceQaEventParams>} LogObject<priorityServiceQaEventParams>
 */
export function priorityServiceQaEvent(params) {
    return { evid: 7, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'priorityStrategy' event (evid: 702)
 *
 * Event description: When Dealer gets a call - it sorts all offers in the placement by a specific strategy. (before targeting + frequency cap check)
 *
 * @param {priorityStrategyParams} params - The parameters for this event
 * @property {GUID} uuid - uuid
 * @property {string} strategy_extra_info - Strategy parameters output
 * @property {string} strategy_properties - site properties (main industry/sub industry/business type)
 * @property {string} strategy - Manual/CTR/CTR - Learning
 * @property {string} priority_offers - List of offers ordered by the chosen strategy before targeting check
 * @property {string} placement_id - placement_id
 * @return {LogObject<priorityStrategyParams>} LogObject<priorityStrategyParams>
 */
export function priorityStrategy(params) {
    return { evid: 702, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'whatSNextPriorityStrategy' event (evid: 703)
 *
 * Event description: debugging what's next priority with every advice from what's next and the offers returned from vespa
 *
 * @param {whatSNextPriorityStrategyParams} params - The parameters for this event
 * @property {boolean} isFallback - if true, dealer reached time out and the user received the fallback strategy
 * @property {string} uuid - uuid
 * @property {string} advice - answer from what's next prompt
 * @property {string} offer_ids_above_threshold - list of offer ids
 * @property {string} offer_ids_above_threshold_with_scores - JSON with offer ids and vespa scores
 * @property {number} advice_index - index of the advice in the what's next answer
 * @return {LogObject<whatSNextPriorityStrategyParams>} LogObject<whatSNextPriorityStrategyParams>
 */
export function whatSNextPriorityStrategy(params) {
    return { evid: 703, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'newNileApplyTargetingComparisonSrc115Evid8' event (evid: 8)
 *
 * Event description: New Nile ApplyTargeting comparison to old targeting for differences monitoring
 *
 * @param {newNileApplyTargetingComparisonSrc115Evid8Params} params - The parameters for this event
 * @property {string} oldApplyTargetingResponse - JSON
 * @property {string} newApplyTargetingResponse - JSON
 * @property {number} oldApplyTargetingDuration - duration of the old request call
 * @property {number} newApplyTargetingDuration - duration of the new request call
 * @property {boolean} isTwoResponseEqual - true/false
 * @property {string} diffBetweenResponsesEqual - JSON diff between responses
 * @property {string} user_context - JSON
 * @return {LogObject<newNileApplyTargetingComparisonSrc115Evid8Params>} LogObject<newNileApplyTargetingComparisonSrc115Evid8Params>
 */
export function newNileApplyTargetingComparisonSrc115Evid8(params) {
    return { evid: 8, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedOnOfferingQuickView' event (evid: 801)
 *
 * Event description: Fired when a user clicks on an offering and it opens the quick-view
 *
 * @param {clickedOnOfferingQuickViewParams} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of offer
 * @property {GUID} realEstateId - placement id
 * @property {GUID} offer_id - id of offer
 * @property {Url} page_url - page url
 * @return {LogObject<clickedOnOfferingQuickViewParams>} LogObject<clickedOnOfferingQuickViewParams>
 */
export function clickedOnOfferingQuickView(params) {
    return { evid: 801, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnTableauReport' event (evid: 802)
 *
 * Event description: Event is fired when an employee clicks on view tableau reports.
 *
 * @param {clickOnTableauReportParams} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of offer
 * @property {GUID} audience - audience_id
 * @property {string} target_url - tableau url
 * @property {GUID} realEstateId - placement
 * @property {GUID} offer_id - id of offer
 * @property {string} entity - Offering/Placement/Campaign/Audience
 * @property {GUID} campaign_id - campaign id
 * @property {Url} page_url - page url
 * @return {LogObject<clickOnTableauReportParams>} LogObject<clickOnTableauReportParams>
 */
export function clickOnTableauReport(params) {
    return { evid: 802, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickedOnQaPreview' event (evid: 803)
 *
 * Event description: Fired when a user clicks on QA & Preview, either from side menu or from offering modal
 *
 * @param {clickedOnQaPreviewParams} params - The parameters for this event
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - name of offer
 * @property {GUID} realEstateId - placement id
 * @property {GUID} offer_id - id of offer
 * @property {Url} page_url - page url
 * @return {LogObject<clickedOnQaPreviewParams>} LogObject<clickedOnQaPreviewParams>
 */
export function clickedOnQaPreview(params) {
    return { evid: 803, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickCreateOffer' event (evid: 804)
 *
 * Event description: Fired when a user clicks on create new offer to indicate weather it was on the header button or on marketing placement
 *
 * @param {clickCreateOfferParams} params - The parameters for this event
 * @property {string} username - user name
 * @property {string} flowType - PlacementCard / HeaderMenu
 * @property {GUID} user_name_uuid - User name id
 * @property {GUID} realEstateId - placement id
 * @property {Url} page_url - Page url
 * @return {LogObject<clickCreateOfferParams>} LogObject<clickCreateOfferParams>
 */
export function clickCreateOffer(params) {
    return { evid: 804, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'clickOnDealerBoOfferMenu' event (evid: 805)
 *
 * Event description: Fired when a user clicks on an item in the dealer offer actions menu
 *
 * @param {clickOnDealerBoOfferMenuParams} params - The parameters for this event
 * @property {string} menu_action - name of the action the user clicked on
 * @property {GUID} offer_Id - ID of offer
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - Name of offer
 * @property {string} action_origin - Home Page| Offers Page Table| Offers Page Side Panel|Placement Page|Campaign Page|Audience Page|New Release Page
 * @property {GUID} realEstateId - Placement ID
 * @property {Url} page_url - Page url
 * @return {LogObject<clickOnDealerBoOfferMenuParams>} LogObject<clickOnDealerBoOfferMenuParams>
 */
export function clickOnDealerBoOfferMenu(params) {
    return { evid: 805, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'viewDealerHelpVideo' event (evid: 806)
 *
 * Event description: event to measure back office use of dealer help videos
 *
 * @param {viewDealerHelpVideoParams} params - The parameters for this event
 * @property {string} video_id - help video guid
 * @property {string} username - username of Wix employee
 * @property {boolean} is_new - is it the first time the user watched this video
 * @property {string} video_name - help video name
 * @property {boolean} is_skipped - indicate if the user skipped forward while watching the video
 * @property {number} completed_percent - percent watched out of the video length
 * @return {LogObject<viewDealerHelpVideoParams>} LogObject<viewDealerHelpVideoParams>
 */
export function viewDealerHelpVideo(params) {
    return { evid: 806, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'actionInDealerOffersPage' event (evid: 807)
 *
 * Event description: Fired when BO user uses filter, search or sorting on the offers table in Dealer Offers page
 *
 * @param {actionInDealerOffersPageParams} params - The parameters for this event
 * @property {string} username - username
 * @property {string} action_origin - Home Page| Offers Page Table| Offers Page Side Panel|Placement Page|Campaign Page|Audience Page|New Release Page
 * @property {string} filter - json containing filter names and an array of filter values
 * @property {string} sort - json containing the field table is sorted by and if asc|desc
 * @property {Url} page_url - page url
 * @property {string} search - table searched term
 * @return {LogObject<actionInDealerOffersPageParams>} LogObject<actionInDealerOffersPageParams>
 */
export function actionInDealerOffersPage(params) {
    return { evid: 807, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'dealerSidePanelAction' event (evid: 808)
 *
 * Event description: Fired when opening or closing the dealer BO side panel
 *
 * @param {dealerSidePanelActionParams} params - The parameters for this event
 * @property {boolean} was_open - indicate if the panel was opened or switched from another offer
 * @property {string} username - username
 * @property {string} action_origin - Home Page| Offers Page Table| Offers Page Side Panel|Placement Page|Campaign Page|Audience Page|New Release Page
 * @property {GUID} offer_id - offer_id
 * @property {Url} page_url - page url
 * @property {string} action - open|close
 * @return {LogObject<dealerSidePanelActionParams>} LogObject<dealerSidePanelActionParams>
 */
export function dealerSidePanelAction(params) {
    return { evid: 808, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'offersTableCtaClick' event (evid: 809)
 *
 * Event description: Click on CTA in dealer backoffice offers table
 *
 * @param {offersTableCtaClickParams} params - The parameters for this event
 * @property {string} action_name - Name of CTA action
 * @property {string} username - name of employee (email prefix)
 * @property {string} offer_name - Name of offer
 * @property {string} action_origin - Home Page| Offers Page Table
 * @property {GUID} realEstateId - Placement ID
 * @property {GUID} offer_id - ID of offer
 * @return {LogObject<offersTableCtaClickParams>} LogObject<offersTableCtaClickParams>
 */
export function offersTableCtaClick(params) {
    return { evid: 809, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateSiteCategoriesRequestToProfileDataService' event (evid: 900)
 *
 * Event description: Request to Profile data service to get site categories, triggered when site is created
 *
 * @param {updateSiteCategoriesRequestToProfileDataServiceParams} params - The parameters for this event
 * @property {GUID} msid - msid
 * @return {LogObject<updateSiteCategoriesRequestToProfileDataServiceParams>} LogObject<updateSiteCategoriesRequestToProfileDataServiceParams>
 */
export function updateSiteCategoriesRequestToProfileDataService(params) {
    return { evid: 900, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateSiteCategoriesResponseFromProfileDataService' event (evid: 901)
 *
 * Event description: Response from profile data service - site categories
 *
 * @param {updateSiteCategoriesResponseFromProfileDataServiceParams} params - The parameters for this event
 * @property {string} subcategory - value of profile field: funnel_site_categories_subcategory
 * @property {string} category - value of profile field: funnel_site_categories_category
 * @property {GUID} msid - msid
 * @return {LogObject<updateSiteCategoriesResponseFromProfileDataServiceParams>} LogObject<updateSiteCategoriesResponseFromProfileDataServiceParams>
 */
export function updateSiteCategoriesResponseFromProfileDataService(params) {
    return { evid: 901, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateSiteCategoriesUpdateCategoriesInSiteProperties' event (evid: 902)
 *
 * Event description: update categories in site properties with Response from profile data service
 *
 * @param {updateSiteCategoriesUpdateCategoriesInSitePropertiesParams} params - The parameters for this event
 * @property {string} subcategory - value of profile field: funnel_site_categories_subcategory
 * @property {string} category - value of profile field: funnel_site_categories_category
 * @property {GUID} msid - msid
 * @property {string} trigger - site_created / bi_profile_event
 * @return {LogObject<updateSiteCategoriesUpdateCategoriesInSitePropertiesParams>} LogObject<updateSiteCategoriesUpdateCategoriesInSitePropertiesParams>
 */
export function updateSiteCategoriesUpdateCategoriesInSiteProperties(params) {
    return { evid: 902, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'updateBusinessSolutionSiteProperties' event (evid: 903)
 *
 * Event description: update wix business solution determined by the dealer in site properties
 *
 * @param {updateBusinessSolutionSitePropertiesParams} params - The parameters for this event
 * @property {string} businessSolution - The resolved business Solution
 * @property {GUID} userGuid - uuid
 * @property {GUID} realEstateId - Placement id (or null if is from migration flow)
 * @property {GUID} offer_id - Dealer offering id (or null if is from migration flow)
 * @property {GUID} msid - msid
 * @property {string} trigger - Which flow triggered that event - can be one of the values: NEW_SITE, SITE_PROPERTIES, OPTIMIZATION_FLOW, SITE_MIGRATION
 * @return {LogObject<updateBusinessSolutionSitePropertiesParams>} LogObject<updateBusinessSolutionSitePropertiesParams>
 */
export function updateBusinessSolutionSiteProperties(params) {
    return { evid: 903, src: 115, endpoint: '', params };
}
/**
 * A function to create a log object for the 'bannerInit' event (evid: 8003)
 *
 * Event description: Banner_Init
 *
 * @param {bannerInitParams} params - The parameters for this event
 * @property {string} lightboxguid - lightboxguid for DA
 * @property {GUID} requestGuid - request_guid
 * @property {GUID} assetCampaignGuid - assetcampaignguid for DA
 * @property {string} realEstateId - 'LIST_TOP' 'LIST_RIGHT' 'LIST_LEFT' ,the location of the asset
 * @property {string} dealerVersion - dealer_version
 * @property {string} assetid - assetid
 * @property {GUID} msid - msid
 * @return {LogObject<bannerInitParams>} LogObject<bannerInitParams>
 */
export function bannerInit(params) {
    return { evid: 8003, src: 17, endpoint: '', params };
}
//# sourceMappingURL=index.js.map